export const NODE_URL = 'https://site2.moralis-nodes.com/base/7c74003aee444699a46ee88fef4a796f';
export const QUICK_NODE_URL = 'https://site1.moralis-nodes.com/base/7c74003aee444699a46ee88fef4a796f';
export const FALLBACK_NODE_URL = 'https://mainnet.base.org';
export const PRESALE_CONTRACT_ADDRESS = '0xAB54759779d52f21004926CC430BB4af54596cD6';
export const DEFAULT_REF_ADDRESS = '0x3D7342942d9CAC4C063705b53CF764FaB4F2847A';
